export default __webpack_public_path__ + "static/media/Wealth-Premier-Brochure.a6d05813.pdf";